"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTO = exports.BOTTOM = exports.TOP = exports.RIGHT = exports.LEFT = void 0;
// LEGEND POSITION TYPES.
// TODO: get rid of these. replace with types in ui-vis-commons where legend is defined
exports.LEFT = "left";
exports.RIGHT = "right";
exports.TOP = "top";
exports.BOTTOM = "bottom";
exports.AUTO = "auto";
//# sourceMappingURL=mess.js.map